import React from "react";
import { useParams } from "react-router-dom";
import styles from "../WeeklyReview.module.scss";
import { Typography } from "@material-ui/core";
import NotesButton from "../../../components/Notes/NotesButton";

const PeopleUpdate = () => {
  const params = useParams();
  return (
    <>
      <Typography variant="h4" align="center">
        Any people updates?
      </Typography>
      <Typography variant="h5" align="center" className={styles.flexCenter}>
        Notes:
        <NotesButton id={params.meeting_id} core="peopleUpdate" model="meeting" size={1.25} />
      </Typography>
    </>
  );
};

export default PeopleUpdate;
